export * from '@egovsolutions/angular-egov-api/watch-lists/common';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@egovsolutions/angular-egov-api/common';
import { createEgovAPIClientError } from '@egovsolutions/angular-egov-api/common';
import { adaptPPTEntities } from '@egovsolutions/angular-egov-api/ppt/internal/basic-models';

class WatchListsNetworkService {
    constructor(api) {
        this.api = api;
    }
    // State
    loadState$() {
        return this.api.request$({ endpoint: 'status/watchlists' }).pipe(map(response => response.WATCHLISTS));
    }
    // Watch Lists
    watchLists$() {
        return this.api.request$({ endpoint: 'watchlist/view' }).pipe(map(response => this.adaptWatchLists(response)));
    }
    // Add watch list
    addWatchList$(name, items) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const bodyParams = { new_watchlist: name };
        if (items)
            bodyParams.watchlist_contents = JSON.stringify({ items });
        return this.api.request$({
            endpoint: 'watchlist/create',
            method: 'POST',
            bodyParameters: bodyParams,
        })
            .pipe(map(response => this.adaptAddWatchList(response)));
    }
    // Delete watch list
    deleteWatchList$(slug) {
        return this.api.request$({
            endpoint: 'watchlist/remove/{{slug}}',
            urlFields: { slug },
            method: 'POST',
        });
    }
    // Add accounts to watch list
    addAccountsToList$(slug, items) {
        return this.api.request$({
            endpoint: 'watchlist/add/{{slug}}',
            urlFields: { slug },
            method: 'POST',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            bodyParameters: { watchlist_contents: JSON.stringify({ items }) }
        });
    }
    // Remove accounts from watch list
    removeAccountsFromList$(slug, items) {
        return this.api.request$({
            endpoint: 'watchlist/remove/{{slug}}',
            urlFields: { slug },
            method: 'POST',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            bodyParameters: { watchlist_contents: JSON.stringify({ items }) }
        });
    }
    // Get accounts for watch list
    getWatchListDetails$(slug) {
        return this.api.request$({ endpoint: 'watchlist/items/{{slug}}', urlFields: { slug } }).pipe(map(response => ({
            ...response,
            ppt: response.ppt?.accounts || response.ppt?.parcels || response.ppt?.bills
                ? adaptPPTEntities(response.ppt.accounts, response.ppt.parcels)
                : undefined,
            btax: response.btax?.accounts || response.btax?.bills ? response.btax : undefined,
        })));
    }
    // Adapters
    adaptWatchLists(source) { return source.watchlists; }
    adaptAddWatchList(source) {
        try {
            const list = JSON.parse(JSON.stringify(source.watchlist));
            return list;
        }
        catch (e) {
            throw createEgovAPIClientError({ message: 'Error loading new list.' });
        }
    }
}
WatchListsNetworkService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: WatchListsNetworkService, deps: [{ token: i1.EgovAPI }], target: i0.ɵɵFactoryTarget.Injectable });
WatchListsNetworkService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: WatchListsNetworkService, providedIn: 'any' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: WatchListsNetworkService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'any' }]
        }], ctorParameters: function () { return [{ type: i1.EgovAPI }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { WatchListsNetworkService };
